import { render } from "./configure.vue?vue&type=template&id=57b67f0d&lang=html"
import script from "./configure.vue?vue&type=script&lang=js"
export * from "./configure.vue?vue&type=script&lang=js"

import "./configure.vue?vue&type=style&index=0&id=57b67f0d&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__